import React, { useRef, useCallback } from 'react';
import styled from 'styled-components';

import { Icon } from 'shared/components/Icon/Icon';
import { cssVar } from 'shared/helpers/styling/styling';

import { withFieldWrapper } from '../FieldWrapper/FieldWrapper';
import { FIELD_UPLOAD } from './constants';

function FieldUpload(props) {
  const { validExtensions, input, multiple, className } = props;

  const ref = useRef(null);

  const onWrapperClick = useCallback(
    e => {
      ref.current.click();
      e.stopPropagation();
    },
    [ref],
  );

  const onLabelClick = useCallback(e => {
    e.preventDefault();
  }, []);

  return (
    <div className={className} onClick={onWrapperClick}>
      <input
        {...input}
        id={input.name}
        ref={ref}
        type="file"
        multiple={multiple}
        accept={validExtensions}
        data-testid="uploadFile"
        value=""
      />
      <label htmlFor={input.name} onClick={onLabelClick}>
        {FIELD_UPLOAD.UPLOAD}
      </label>
      <Icon icon="icon-upload" />
    </div>
  );
}

const FieldUploadStyled = withFieldWrapper(styled(FieldUpload)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px 0 32px;
  height: 50px;
  font-size: 0.875rem;
  color: ${cssVar('rollingStone')};
  background-color: transparent;
  border: 2px dashed ${cssVar('dustGray')};
  border-radius: 5px;
  cursor: pointer;

  :hover {
    background-color: ${cssVar('limedSpruceDarker')};
  }

  input {
    display: none;
  }

  label {
    margin-bottom: 0;
    cursor: pointer;
  }
`);

export { FieldUploadStyled as FieldUpload };
